import { restRequest } from "../../redux/utilities";
export var SET_CLIENT_CONFIG = "SET_CLIENT_CONFIG";
export var LOGOUT = "LOGOUT";
export var REPLACE_REDUCERS = "REPLACE_REDUCERS";
export var SECURITY = restRequest("SECURITY");
export var GET_USERS = restRequest("GET_USERS");
export var GET_JOBPACKS = restRequest("GET_JOBPACKS");
export var GET_FEED = restRequest("GET_FEED");
export var GET_GROUPS = restRequest("GET_GROUPS");